import RegisterAdviserLogic from "../Application/RegisterAdviser.logic";
import GetAdviserInfoLogic from "../Application/GetAdviserInfo.logic";
import { GetAdviserListLogic, GetAdviserListBySearchBarLogic } from "../Application/GetAdviserList.logic";

export async function GetAdviserInfo() {
  const info = await GetAdviserInfoLogic(localStorage.getItem("id"));
  return { info };
}

export async function GetAdviserList(zone) {
  return await GetAdviserListLogic(zone);
}

export async function GetAdviserListBySearchBar(zone, name) {
  return await GetAdviserListBySearchBarLogic(zone, name);
}

export async function RegisterAdviser(
  email,
  password,
  passwordRepeat,
  name,
  lastName,
  sex,
  address,
  age,
  phone
) {
  return RegisterAdviserLogic(
    email,
    password,
    passwordRepeat,
    name,
    lastName,
    sex,
    address,
    age,
    phone
  );
}